<template>
	<div class="pages">
		<navTop></navTop>
		<div class="box">
			<div class="box-main">
				<div class="box-main-top">
					<div class="box-main-top-left">
						<p>
							You will need to pay the overtime cancellation fee because the
							cancellation time is exceeded
						</p>
						<p>Cost：${{ money }}</p>
					</div>
					<div class="box-main-top-right"><img src="" /></div>
				</div>
				<div class="box-main-reason">
					<div class="box-main-reason-left">
						Please select cancellation reason
					</div>
					<select class="box-main-reason-right" @change="fnselect($event)">
						<option v-for="(item, index) in cancelList" :key="index">
							{{ item.name }}
						</option>
					</select>
				</div>
				<p class="box-main-explain">Explain</p>
				<textarea
					class="box-main-textarea"
					v-model="content"
					placeholder="Please enter more reasons"
				></textarea>
				<div class="box-main-btn" @click="subimt">Determine</div>
			</div>
		</div>
	</div>
</template>

<script>
import navTop from '../../components/navTop.vue';
export default {
	name: 'overtimeCancel',
	components: {
		navTop
	},
	data() {
		return {
			id: '',
			money: '',
			content: '',
			text: '',
			cancelList: []
		};
	},
	created() {
		if (!sessionStorage.getItem('uid')) {
			this.$router.push({ path: '/' });
		} else {
			this.id = this.$route.query.id;
			this.money = this.$route.query.money;
			this.getCancelreason();
		}
	},
	methods: {
		getCancelreason() {
			let data = {
				type: 1
			};
			this.$api.cancelreason(data).then(res => {
				console.log(res);
				if (res.result == 0) {
					this.cancelList = res.dataList;
					this.text = res.dataList[0].name;
				}
			});
		},
		fnselect(e) {
			this.text = e.target.value;
		},
		subimt() {
			if (this.content == '') {
				this.$message({
					message: 'Please fill in the reason for cancellation',
					type: 'error',
					center: true,
					duration: 1000
				});
				return;
			}
			let data = {
				id: this.id,
				type: 1,
				cancelReason: this.text,
				money: this.money,
				cancelDetail: this.content
			};
			this.$api.cancel(data).then(res => {
				console.log(res);
				if (res.result == 0) {
					this.$router.push({ path: '/success', query: { num: 2 } });
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.pages {
	background: #3E414A;
	.box {
		padding-top: 64px;
		padding-bottom: 130px;
		box-sizing: border-box;
		.box-main {
			width: 100%;
			border-radius: 38px;
			padding: 72px 173px 68px 95px;
			box-sizing: border-box;
			background-image: url(../../assets/details-case2.png);
			background-size: 100% 100%;
			.box-main-top {
				display: flex;
				align-items: flex-start;
				justify-content: space-between;
				.box-main-top-left {
					p:nth-child(1) {
						font-size: 30px;
						color: #00fff0;
						line-height: 1em;
					}
					p:nth-child(2) {
						margin-top: 46px;
						font-size: 30px;
						color: #00fff0;
						line-height: 1em;
					}
				}
				.box-main-top-right {
					padding-top: 5px;
					box-sizing: border-box;
					img {
						width: 160px;
						height: 120px;
						display: block;
					}
				}
			}
			.box-main-reason {
				margin-top: 100px;
				display: flex;
				align-items: center;
				.box-main-reason-left {
					font-size: 24px;
					color: #00fff0;
					line-height: 1em;
				}
				.box-main-reason-right {
					outline: none;
					margin-left: 33px;
					width: 466px;
					height: 50px;
					background: rgba(35, 254, 246, 0.1);
					border: 1px solid #48ece7;
					padding: 0 20px;
					box-sizing: border-box;
					font-weight: 400;
					color: #13fffc;
					line-height: 1em;
					option {
						background: #000;
						color: #00d9dd;
					}
				}
			}
			.box-main-explain {
				font-size: 24px;
				color: #00fff0;
				line-height: 1em;
				margin-top: 42px;
			}
			.box-main-textarea {
				margin-top: 30px;
				width: 100%;
				height: 159px;
				background: rgba(35, 254, 246, 0.1);
				border: 1px solid #48ece7;
				outline: none;
				resize: none;
				padding: 17px 20px;
				box-sizing: border-box;
				font-weight: 400;
				color: #13fffc;
				line-height: 28px;
			}
			.box-main-textarea::-webkit-input-placeholder {
				color: #13fffc;
			}
			.box-main-btn {
				width: 100%;
				height: 60px;
				background: linear-gradient(
					90deg,
					rgba(29, 175, 170, 0.8) 0%,
					rgba(35, 254, 246, 0.8) 100%
				);
				font-size: 24px;
				font-family: Adobe Heiti Std;
				font-weight: normal;
				color: #f6f6f6;
				line-height: 60px;
				text-align: center;
				margin: 46px auto 0;
			}
		}
	}
}
</style>
